// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonBoolean = {
  yes: "Yes",
  no: "No",
} as const;
